// Возвращает форму существительного для числа n по правилам русского языка:
// one — форма для 1 (камера), few — для 2–4 (камеры), many — для 5+ (камер).
export function pluralize(n: number, one: string, few: string, many: string): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return few;
  return many;
}
